import { TimePicker } from 'antd';

TimePicker.defaultProps = {
  allowClear: true,
};

export default TimePicker;
